import ContactCentre from '../../components/contact-center/ContactCentre';

export default function ContactCentrePage() {
  return <ContactCentre />;
}
